import React from "react";

const Media = () => {
  return <div className="container"></div>;
};

export default Media;
